import React from "react";
import PropTypes from "prop-types";
import AnimatedCard from "../AnimatedCard/AnimatedCard";
import Button from "../../atoms/Button/Button";
import "./ConfirmDialog.scss";

const ConfirmDialog = ({
    isOpen,
    onClose,
    onConfirm,
    title = "Confirmar Acción",
    message = "¿Estás seguro de que deseas continuar?",
    confirmText = "Confirmar",
    cancelText = "Cancelar",
    type = "danger", // danger, warning, info
    itemName = null,
}) => {
    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    const getIcon = () => {
        switch (type) {
            case "danger":
                return "🗑️";
            case "warning":
                return "⚠️";
            case "info":
                return "ℹ️";
            default:
                return "❓";
        }
    };

    return (
        <AnimatedCard
            setClose={onClose}
            size="sm"
            variant="elegant"
            showHeader={false}
            centerContent={true}
        >
            <div className="confirm-dialog">
                <div
                    className={`confirm-dialog__icon confirm-dialog__icon--${type}`}
                >
                    <span>{getIcon()}</span>
                </div>

                <h2 className="confirm-dialog__title">{title}</h2>

                <p className="confirm-dialog__message">
                    {message}
                    {itemName && (
                        <span className="confirm-dialog__item-name">
                            "{itemName}"
                        </span>
                    )}
                </p>

                <div className="confirm-dialog__actions">
                    <Button
                        text={cancelText}
                        onClick={onClose}
                        // className="confirm-dialog__btn-cancel"
                        className="outlet"
                    />
                    <Button
                        text={confirmText}
                        onClick={handleConfirm}
                        className="cancel"
                        // className={`confirm-dialog__btn-confirm confirm-dialog__btn-confirm--${type} question`}
                    />
                </div>
            </div>
        </AnimatedCard>
    );
};

ConfirmDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    type: PropTypes.oneOf(["danger", "warning", "info"]),
    itemName: PropTypes.string,
};

export default ConfirmDialog;
